import { DATE_FORMAT_YYYYMMDD } from "@app/constants";
import { StatisticsType } from "@app/constants/statistics.const";
import { StatisticsState } from "@app/types";
import dayjs from "dayjs";

export const initialStateStatistics = Object.freeze<StatisticsState>({
  typeChart: StatisticsType[0],
  typeUser: { label: "ALL", value: "ALL" },
  voucherCode: "",
  filterDate: "allTime",
  startDate: undefined,
  endDate: undefined,
  startDateTemp: undefined,
  endDateTemp: undefined,
  userType: [],
  userTypeTemp: [],
  bookIds: [],
  dataVoucherActiveInteraction: [],
  totalListener: 0,
});

export const calculateDateTemp = (
  value: string,
  startDate?: string,
  endDate?: string
) => {
  let startDateTemp = startDate;
  let endDateTemp = endDate;

  switch (value) {
    case "thisWeek":
      startDateTemp = dayjs().startOf("week").format(DATE_FORMAT_YYYYMMDD);
      endDateTemp = dayjs().endOf("week").format(DATE_FORMAT_YYYYMMDD);
      break;
    case "lastWeek":
      startDateTemp = dayjs()
        .subtract(1, "week")
        .startOf("week")
        .format(DATE_FORMAT_YYYYMMDD);
      endDateTemp = dayjs()
        .subtract(1, "week")
        .endOf("week")
        .format(DATE_FORMAT_YYYYMMDD);
      break;
    case "thisMonth":
      startDateTemp = dayjs().startOf("month").format(DATE_FORMAT_YYYYMMDD);
      endDateTemp = dayjs().endOf("month").format(DATE_FORMAT_YYYYMMDD);
      break;
    case "lastMonth":
      startDateTemp = dayjs()
        .subtract(1, "month")
        .startOf("month")
        .format(DATE_FORMAT_YYYYMMDD);
      endDateTemp = dayjs()
        .subtract(1, "month")
        .endOf("month")
        .format(DATE_FORMAT_YYYYMMDD);
      break;
    case "thisYear":
      startDateTemp = dayjs().startOf("year").format(DATE_FORMAT_YYYYMMDD);
      endDateTemp = dayjs().endOf("year").format(DATE_FORMAT_YYYYMMDD);
      break;
    case "lastYear":
      startDateTemp = dayjs()
        .subtract(1, "year")
        .startOf("year")
        .format(DATE_FORMAT_YYYYMMDD);
      endDateTemp = dayjs()
        .subtract(1, "year")
        .endOf("year")
        .format(DATE_FORMAT_YYYYMMDD);
      break;
    case "allTime":
      startDateTemp = undefined;
      endDateTemp = undefined;
      break;
  }

  return { startDateTemp, endDateTemp };
};
